import React from "react";
import {
    Modal,
    Box,
    Typography,
    IconButton,
    Divider,
    Stack,
    Grid,
    Avatar,
    Button,
    Collapse,
    Paper,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { getInitials, stringToColor } from "../utils/DataHelper";
import dayjs from "dayjs";
import axios from '../api/axiosConfig'

export default function JemaatDetailModal({ open, onClose, data, title = "Record Detail" }) {
    const [updateMember, setUpdateMember] = React.useState(false);

    const [joinDate, setJoinDate] = React.useState(new Date().toISOString().split("T")[0]);
    const [memberFee, setMemberFee] = React.useState(2500);
    const [memberStatus, setMemberStatus] = React.useState("add");

    const [loading, setLoading] = React.useState(false);


    const avatarColor = stringToColor(data?.name_full);

    const [confirmOpen, setConfirmOpen] = React.useState(false);

    const UpdateToMember = () => {
        // Open confirmation dialog
        setConfirmOpen(true);
    };

    const UpdateToMemberConfirmed = async () => {
        // Implementation for updating member details
        const payload = {
            methode: memberStatus,
            datestart: joinDate,
            amount: memberFee,
            idjemaat: data.idjemaat,
        };
        console.log("Update Member Payload:", payload);
        try {
            setLoading(true);

            const url = `/memberfromjemaat.php`;

            const resp = await axios.post(url, payload);
            console.log("Update Member Response:", resp.data);
            // Handle success (e.g., show a notification, refresh data, etc.)
            alert("Member status updated successfully!");
            setLoading(false);
            onClose();
        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setLoading(false);
        }
    }



    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "70%",
                    maxHeight: "80vh",
                    display: "flex",
                    flexDirection: "column",
                    bgcolor: "background.paper",
                    borderRadius: 3,
                    boxShadow: 24,
                }}
            >
                {/* Header */}
                <Box sx={{ p: 3, position: "relative" }}>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                        {data && (
                            <>
                                <Avatar
                                    sx={{
                                        bgcolor: avatarColor,
                                        color: "#fff",
                                        fontWeight: 700,
                                        width: 42,
                                        height: 42,
                                        fontSize: 15,
                                    }}
                                >
                                    {getInitials(data.name_full)}
                                </Avatar>

                                <Box flex={1}>
                                    <Typography variant="h5" fontWeight={700}>
                                        {data.name_full}
                                    </Typography>
                                    <Stack direction="row" spacing={0.5}>
                                        <Typography variant="body2" color="text.secondary">
                                            {data.idjemaat || "---"}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">•</Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {data.name_nick || "---"}
                                        </Typography>
                                    </Stack>
                                </Box>
                            </>
                        )}

                        <IconButton
                            onClick={onClose}
                            sx={{ position: "absolute", top: 8, right: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                </Box>

                <Divider />


                <Box sx={{
                    overflowY: "auto",
                    maxHeight: "60vh",
                    pr: 1, p: 2
                }}>
                    <Box sx={{
                        flex: 1, overflowY: "auto",  // 👈 scrolling here
                        p: 3,
                    }}>
                        {data ? (
                            <Box >
                                <Grid container spacing={1}>
                                    <Grid size={{ xs: 12 }}>
                                        <HVText accentColor={avatarColor} label="Alamat" value={data.alamat} />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <HVText accentColor={avatarColor} label="Kelahiran" value={data.lahir_tempat} />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <HVText accentColor={avatarColor} label="Tanggal Lahir" value={dayjs(data.lahir_date).format("DD MMMM YYYY")} />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <HVText accentColor={avatarColor} label="Gender" value={data.gender === "L" ? "Laki-laki" : "Perempuan"} />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <HVText accentColor={avatarColor}
                                            label="Terdaftar Betania"
                                            value={
                                                data.isbetaniamember === 1 ?
                                                    dayjs(data.betaniamemberestablished)
                                                        .format("DD MMMM YYYY") : "Non-member"

                                            } />
                                    </Grid>
                                </Grid>
                            </Box>


                        ) : (
                            <Typography color="text.secondary" align="center">
                                No data available
                            </Typography>
                        )}
                    </Box>
                     

                    <Divider sx={{ my: 2 }} />

                    <Collapse in={updateMember} >

                        {data?.isbetaniamember === 0 ? (
                            <Box sx={{ p: 2, mb: 2, border: '1px solid #e0e0e0', background: '#f5f5f5' }} >
                                <Stack direction={'row'} spacing={1} alignItems="center" mb={1} >
                                    <EditIcon sx={{ color: '#f57c00', fontSize: 24 }} />
                                    <Typography variant="h6" gutterBottom color="#f57c00">
                                        Update Jemaat ke Member Betania
                                    </Typography>
                                </Stack>

                                {/* Additional form fields for updating to member can be added here */}
                                <Grid container spacing={2} mt={3} >
                                    <Grid size={{ xs: 12, sm: 4 }} >
                                        <TextField
                                            value={memberStatus}
                                            onChange={(e) => setMemberStatus(e.target.value)}
                                            fullWidth label="Update menjadi"
                                            select SelectProps={{ native: true }}
                                        >
                                            <option value="add" >Member</option>
                                            <option value="remove" >Non-Member</option>
                                        </TextField>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 4 }} >
                                        <TextField
                                            value={joinDate}
                                            onChange={(e) => setJoinDate(e.target.value)}
                                            fullWidth label="Tanggal Bergabung"
                                            type="date" InputLabelProps={{ shrink: true }} />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 4 }} >
                                        <TextField
                                            value={memberFee}
                                            onChange={(e) => setMemberFee(e.target.value)}
                                            fullWidth label="Nominal Iuran" />
                                    </Grid>

                                </Grid>

                                <Stack direction={'row'} spacing={2} mt={2} >
                                    <Paper sx={{
                                        borderRadius: 2,
                                        border: '1px solid #ffe0b2',
                                        px: 3, py: 2, mb: 2, bgcolor: "#fff6e7"
                                    }} >
                                        <Typography variant="body2" color="text.secondary" >
                                            Fitur ini akan mengubah status jemaat menjadi member Betania. Pastikan semua data sudah benar sebelum melanjutkan.
                                        </Typography>
                                    </Paper>
                                    <Button variant="contained"
                                        onClick={UpdateToMember}
                                        color={"primary"}  > {loading ? "Updating..." : "Update to Member Betania"}
                                    </Button>
                                </Stack>

                            </Box>
                        ) : (
                            <Typography sx={{ p: 2 }} color="text.secondary" >
                                Jemaat ini sudah berstatus Member Betania
                            </Typography>
                        )}
                    </Collapse>


                </Box>
                <Divider />

                <Box
                    sx={{
                        p: 2,
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1,
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={() => setUpdateMember(!updateMember)}
                        color={updateMember ? "error" : "primary"}
                    >
                        {updateMember ? "Batal Update" : "Update Membership"}
                    </Button>

                    <Button variant="outlined" onClick={onClose}>
                        Tutup
                    </Button>
                </Box>



                <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
                    <DialogTitle>Konfirmasi</DialogTitle>

                    <DialogContent>
                        <Typography>
                            Apakah Anda yakin ingin memperbarui status member ini?
                        </Typography>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={() => setConfirmOpen(false)}>
                            Tidak
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={async () => {
                                setConfirmOpen(false);
                                await UpdateToMemberConfirmed();
                            }}
                        >
                            Ya, Lanjutkan
                        </Button>
                    </DialogActions>
                </Dialog>

            </Box>


        </Modal>

    );
}

const HVText = ({
    label,
    value,
    accentColor = "#9e5bad",
    minHeight = 72,
}) => {
    const displayValue =
        value === null || value === undefined || value === ""
            ? "-"
            : value;

    return (
        <Box
            sx={{
                overflow: "hidden",
                borderRadius: 1.5,
                border: "1px solid #dddee0",
                transition: "all .2s ease",
                "&:hover": {
                    bgcolor: "action.hover",
                    transform: "translateY(-1px)",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                },
            }}
        >
            <Stack direction="row" alignItems="stretch">
                {/* Accent bar */}
                <Box
                    sx={{
                        width: 6,
                        bgcolor: accentColor,
                        minHeight,
                    }}
                />

                {/* Content */}
                <Box flex={1} sx={{ px: 2, py: 1.2 }}>
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ fontWeight: 600 }}
                    >
                        {label}
                    </Typography>

                    <Typography
                        variant="body1"
                        color="text.primary"
                        sx={{ fontWeight: 500 }}
                    >
                        {displayValue}
                    </Typography>
                </Box>
            </Stack>
        </Box>
    );
};
